"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE_MANAGEMENT_ROLES = void 0;
var FILE_MANAGEMENT_ROLES;
(function (FILE_MANAGEMENT_ROLES) {
    FILE_MANAGEMENT_ROLES["VIEW_FILE"] = "view-file";
    FILE_MANAGEMENT_ROLES["UPLOAD_FILE"] = "upload-file";
    FILE_MANAGEMENT_ROLES["DELETE_FILE"] = "delete-file";
    FILE_MANAGEMENT_ROLES["MODIFY_FILE"] = "modify-file";
})(FILE_MANAGEMENT_ROLES = exports.FILE_MANAGEMENT_ROLES || (exports.FILE_MANAGEMENT_ROLES = {}));
//# sourceMappingURL=file-management.roles.js.map